import React from "react";
import ReactDOM from "react-dom";
import Img from "../../common/Img";

export default function LiveTrackerContainer(props) {
    function handleDragStart(e) {
        props.move();
        e.dataTransfer.setData('text/plain', 0);
        e.dataTransfer.effectAllowerd = 'move';
    }

    return ReactDOM.createPortal(
        <div className="c_60" style={{...props.position}} draggable={true} onDragStart={handleDragStart}>
            <Img className="c_60_1" src="icon_close.svg" height="32px" width="32px" onClick={props.close} />
            {props.children}
        </div>
        , document.querySelector('.c_1')
    );
}
